/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListTeamMembersRequest = {
  orgId: string;
  teamId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

export type Members = {
  id: string;
  teamId: string;
  userId: string;
  createdAt: string;
};

/**
 * OK
 */
export type ListTeamMembersResponseBody = {
  members: Array<Members>;
};

/** @internal */
export const ListTeamMembersRequest$inboundSchema: z.ZodType<
  ListTeamMembersRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  orgId: z.string(),
  teamId: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListTeamMembersRequest$Outbound = {
  orgId: string;
  teamId: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListTeamMembersRequest$outboundSchema: z.ZodType<
  ListTeamMembersRequest$Outbound,
  z.ZodTypeDef,
  ListTeamMembersRequest
> = z.object({
  orgId: z.string(),
  teamId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listTeamMembersRequestToJSON(
  listTeamMembersRequest: ListTeamMembersRequest,
): string {
  return JSON.stringify(
    ListTeamMembersRequest$outboundSchema.parse(listTeamMembersRequest),
  );
}
export function listTeamMembersRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListTeamMembersRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListTeamMembersRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListTeamMembersRequest' from JSON`,
  );
}

/** @internal */
export const Members$inboundSchema: z.ZodType<Members, z.ZodTypeDef, unknown> =
  z.object({
    id: z.string(),
    teamId: z.string(),
    userId: z.string(),
    createdAt: z.string(),
  });
/** @internal */
export type Members$Outbound = {
  id: string;
  teamId: string;
  userId: string;
  createdAt: string;
};

/** @internal */
export const Members$outboundSchema: z.ZodType<
  Members$Outbound,
  z.ZodTypeDef,
  Members
> = z.object({
  id: z.string(),
  teamId: z.string(),
  userId: z.string(),
  createdAt: z.string(),
});

export function membersToJSON(members: Members): string {
  return JSON.stringify(Members$outboundSchema.parse(members));
}
export function membersFromJSON(
  jsonString: string,
): SafeParseResult<Members, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Members$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Members' from JSON`,
  );
}

/** @internal */
export const ListTeamMembersResponseBody$inboundSchema: z.ZodType<
  ListTeamMembersResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  members: z.array(z.lazy(() => Members$inboundSchema)),
});
/** @internal */
export type ListTeamMembersResponseBody$Outbound = {
  members: Array<Members$Outbound>;
};

/** @internal */
export const ListTeamMembersResponseBody$outboundSchema: z.ZodType<
  ListTeamMembersResponseBody$Outbound,
  z.ZodTypeDef,
  ListTeamMembersResponseBody
> = z.object({
  members: z.array(z.lazy(() => Members$outboundSchema)),
});

export function listTeamMembersResponseBodyToJSON(
  listTeamMembersResponseBody: ListTeamMembersResponseBody,
): string {
  return JSON.stringify(
    ListTeamMembersResponseBody$outboundSchema.parse(
      listTeamMembersResponseBody,
    ),
  );
}
export function listTeamMembersResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<ListTeamMembersResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListTeamMembersResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListTeamMembersResponseBody' from JSON`,
  );
}
